(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-zendesk-contact]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const messages = JSON.parse(form.querySelector('[data-contact-messages]').textContent);
      const button = form.querySelector('button[type="submit"]');
      const buttonLabel = button.querySelector('span');
      const originalLabel = buttonLabel.textContent;
      const errorBox = form.querySelector('[data-contact-error]');
      const successBox = form.querySelector('[data-contact-success]');
      const fields = form.querySelector('[data-contact-fields]');
      const subject = form.elements.namedItem('contact[subject]');
      const preset = new URLSearchParams(location.search).get('subject');
      if (preset && Array.from(subject.options).some((option) => option.value === preset)) subject.value = preset;
      button.disabled = false;
      let busy = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        errorBox.hidden = true;
        const data = new FormData(form);
        const value = (key) => String(data.get(`contact[${key}]`) || '').trim();
        const file = form.querySelector('input[type="file"]').files[0];
        const showError = (message) => {
          errorBox.textContent = message;
          errorBox.hidden = false;
          errorBox.focus();
        };
        if (file && file.size > 20 * 1024 * 1024) {
          showError(messages.too_large);
          return;
        }
        busy = true;
        button.disabled = true;
        buttonLabel.textContent = messages.sending;
        form.setAttribute('aria-busy', 'true');
        let stage = 'upload';
        let uncertain = false;
        try {
          const uploads = [];
          if (file) {
            form.dataset.stage = 'upload';
            const response = await fetch(`https://repetto.zendesk.com/api/v2/uploads.json?filename=${encodeURIComponent(file.name)}`, {
              method: 'POST', credentials: 'omit',
              headers: { 'Content-Type': file.type || 'application/octet-stream' },
              body: file, signal: AbortSignal.timeout(60000)
            });
            form.dataset.uploadStatus = String(response.status);
            if (!response.ok) throw new Error(`Upload HTTP ${response.status}`);
            const result = await response.json();
            if (!result.upload?.token) throw new Error('Missing upload token');
            uploads.push(result.upload.token);
            form.dataset.attachmentId = String(result.upload.attachment?.id || '');
          }
          stage = 'request';
          form.dataset.stage = stage;
          const details = [value('body'), '', ...Array.from(data.entries())
            .filter(([key]) => key.startsWith('contact[') && key !== 'contact[body]')
            .map(([key, fieldValue]) => `${key.slice(8, -1)}: ${String(fieldValue).trim()}`), `locale: ${form.dataset.locale}`].join('\n');
          const request = {
            requester: { name: `${value('firstname')} ${value('lastname')}`, email: value('email'), locale: form.dataset.locale },
            subject: value('subject'), ticket_form_id: 30575525425436,
            comment: { body: details, uploads },
            custom_fields: [
              { id: 30574310546332, value: value('firstname') },
              { id: 30574380580764, value: value('lastname') },
              { id: 30574507791772, value: value('email') },
              { id: 30575488647452, value: value('theme') },
              { id: 30574784601500, value: value('order') }
            ]
          };
          let response;
          try {
            response = await fetch('https://repetto.zendesk.com/api/v2/requests.json', {
              method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ request }), signal: AbortSignal.timeout(60000)
            });
          } catch (error) { uncertain = true; throw error; }
          form.dataset.requestStatus = String(response.status);
          if (!response.ok) throw new Error(`Request HTTP ${response.status}`);
          const result = await response.json();
          if (result.suspended_ticket?.id) {
            form.dataset.suspendedTicketId = String(result.suspended_ticket.id);
            form.dataset.stage = 'pending-verification';
            successBox.textContent = messages.verify_email;
          } else if (result.request?.id) {
            form.dataset.requestId = String(result.request.id);
            form.dataset.stage = 'complete';
          } else {
            uncertain = true;
            throw new Error('Missing request id');
          }
          successBox.hidden = false;
          fields.hidden = true;
          successBox.focus();
        } catch (error) {
          form.dataset.stage = `${stage}-failed`;
          console.warn(`Zendesk contact ${stage}: ${error.message}`);
          showError(uncertain ? messages.uncertain : stage === 'upload' ? messages.upload_error : messages.send_error);
        } finally {
          busy = uncertain;
          button.disabled = uncertain;
          buttonLabel.textContent = originalLabel;
          form.removeAttribute('aria-busy');
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-placeholders"]) return;
  try {
    
  if (!customElements.get('repetto-contact-placeholders')) {
    customElements.define('repetto-contact-placeholders', class extends HTMLElement {
      connectedCallback() {
        this.styles = new Set();
        this.install = () => {
          const hosts = document.querySelectorAll('[data-forms-id="forms-root-1164744"] shopify-forms-embed');
          let pending = hosts.length === 0;
          hosts.forEach((host) => {
            const root = host.shadowRoot;
            if (!root) {
              pending = true;
              return;
            }
            if (root.querySelector('[data-repetto-placeholders]')) return;
            const english = document.documentElement.lang.toLowerCase().startsWith('en');
            const style = document.createElement('style');
            style.dataset.repettoPlaceholders = '';
            style.textContent = `
              [id="custom#sujet-selector-value"]:empty::before {
                content: "${english ? 'Select a subject…' : 'Sélectionnez un sujet…'}";
                color: #6b6b6b;
              }
              [id="custom#pays-selector-value"]:empty::before {
                content: "${english ? 'Select a country…' : 'Sélectionnez un pays…'}";
                color: #6b6b6b;
              }
            `;
            root.append(style);
            this.styles.add(style);
          });
          if (!pending || Date.now() > this.deadline) clearInterval(this.timer);
        };
        this.restart = () => {
          clearInterval(this.timer);
          this.deadline = Date.now() + 30000;
          this.timer = setInterval(this.install, 250);
          this.install();
        };
        this.observer = new MutationObserver((records) => {
          if (records.some(record => Array.from(record.addedNodes).some(node =>
            node.nodeType === 1 && (node.matches('shopify-forms-embed, [data-forms-id="forms-root-1164744"]') ||
              node.querySelector('[data-forms-id="forms-root-1164744"], shopify-forms-embed'))
          ))) this.restart();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.restart();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
        this.styles?.forEach(style => style.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const galleryPlayers = new Set();

    class GalleryPlayer {
      constructor(element) {
        this.element = element;
        this.provider = element.dataset.galleryProvider;
        this.video = element.querySelector('video');
        this.iframe = element.querySelector('iframe');
        this.playbackButton = element.querySelector('[data-gallery-toggle="playback"]');
        this.muteButton = element.querySelector('[data-gallery-toggle="mute"]');

        this.togglePlayback = this.togglePlayback.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.syncHostedPlayback = this.syncHostedPlayback.bind(this);
        this.syncHostedMute = this.syncHostedMute.bind(this);

        this.bindEvents();
        this.syncStateFromMarkup();
        galleryPlayers.add(this);
      }

      bindEvents() {
        if (this.playbackButton) {
          this.playbackButton.addEventListener('click', this.togglePlayback);
        }

        if (this.muteButton) {
          this.muteButton.addEventListener('click', this.toggleMute);
        }

        if (this.provider === 'shopify' && this.video) {
          this.video.addEventListener('play', this.syncHostedPlayback);
          this.video.addEventListener('pause', this.syncHostedPlayback);
          this.video.addEventListener('volumechange', this.syncHostedMute);
        }
      }

      syncStateFromMarkup() {
        if (this.provider === 'shopify' && this.video) {
          this.setPlayingState(!this.video.paused);
          this.setMutedState(this.video.muted);
          return;
        }

        this.setPlayingState(this.element.dataset.galleryPlaying !== 'false');
        this.setMutedState(this.element.dataset.galleryMuted !== 'false');
      }

      syncHostedPlayback() {
        if (this.video) {
          this.setPlayingState(!this.video.paused);
        }
      }

      syncHostedMute() {
        if (this.video) {
          this.setMutedState(this.video.muted || this.video.volume === 0);
        }
      }

      togglePlayback(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.element.dataset.galleryPlaying === 'true') {
          this.pause();
          return;
        }

        this.play();
      }

      toggleMute(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.element.dataset.galleryMuted === 'true') {
          this.unmute();
          return;
        }

        this.mute();
      }

      play() {
        if (this.provider === 'shopify' && this.video) {
          const playPromise = this.video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }

          this.setPlayingState(true);
          return;
        }

        if (this.provider === 'youtube') {
          this.postMessage({ event: 'command', func: 'playVideo', args: '' });
        } else if (this.provider === 'vimeo') {
          this.postMessage({ method: 'play' });
        }

        this.setPlayingState(true);
      }

      pause() {
        if (this.provider === 'shopify' && this.video) {
          this.video.pause();
          this.setPlayingState(false);
          return;
        }

        if (this.provider === 'youtube') {
          this.postMessage({ event: 'command', func: 'pauseVideo', args: '' });
        } else if (this.provider === 'vimeo') {
          this.postMessage({ method: 'pause' });
        }

        this.setPlayingState(false);
      }

      mute() {
        if (this.provider === 'shopify' && this.video) {
          this.video.muted = true;
          this.setMutedState(true);
          return;
        }

        if (this.provider === 'youtube') {
          this.postMessage({ event: 'command', func: 'mute', args: '' });
        } else if (this.provider === 'vimeo') {
          this.postMessage({ method: 'setMuted', value: true });
          this.postMessage({ method: 'setVolume', value: 0 });
        }

        this.setMutedState(true);
      }

      unmute() {
        this.muteOtherPlayers();

        if (this.provider === 'shopify' && this.video) {
          this.video.muted = false;
          this.video.volume = 1;
          this.setMutedState(false);
          return;
        }

        if (this.provider === 'youtube') {
          this.postMessage({ event: 'command', func: 'unMute', args: '' });
        } else if (this.provider === 'vimeo') {
          this.postMessage({ method: 'setMuted', value: false });
          this.postMessage({ method: 'setVolume', value: 1 });
        }

        this.setMutedState(false);
      }

      muteOtherPlayers() {
        galleryPlayers.forEach((player) => {
          if (!player.element.isConnected) {
            galleryPlayers.delete(player);
            return;
          }

          if (player === this) {
            return;
          }

          if (player.element.dataset.galleryMuted === 'false') {
            player.mute();
          }
        });
      }

      postMessage(payload) {
        if (!this.iframe || !this.iframe.contentWindow) {
          return;
        }

        this.iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
      }

      setPlayingState(isPlaying) {
        this.element.dataset.galleryPlaying = isPlaying ? 'true' : 'false';

        if (this.playbackButton) {
          this.playbackButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
        }
      }

      setMutedState(isMuted) {
        this.element.dataset.galleryMuted = isMuted ? 'true' : 'false';

        if (this.muteButton) {
          this.muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
        }
      }
    }

    const initGalleryPlayers = (scope = document) => {
      scope.querySelectorAll('[data-gallery-player]').forEach((element) => {
        if (element.dataset.galleryPlayerReady === 'true') {
          return;
        }

        element.dataset.galleryPlayerReady = 'true';
        new GalleryPlayer(element);
      });
    };

    if (window.initGalleryPlayers) {
      window.initGalleryPlayers();
      return;
    }

    window.initGalleryPlayers = initGalleryPlayers;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initGalleryPlayers());
    } else {
      initGalleryPlayers();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initGalleryPlayers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
